let next = 1
const seq = (): number => next++

export default seq
